export const payTypeOptions = [
  {label: '微信', value: 1},
  {label: '支付宝', value: 2},
];


export const payTypeEnum = {
  wx: 1,
  alipay: 2
}
